import React from "react";
import PropTypes from "prop-types";

import { Column, Control, Label, Input } from "rbx";

import { BooleanInput, SystemCodeSelect } from "../inputs";
import { useSystemCodes } from "../../utils/hooks";

const ItemCategoryForm = ({ inputs, onChange }) => {
  const CategoryTypes = useSystemCodes({
    Category: "Fleet",
    CodeName: "WOType"
  });
  return (
    <div style={{ width: 600, maxWidth: "80vw" }}>
      <Column.Group>
        <Column size={5}>
          <Control>
            <Label>Item Category Code</Label>
            <Input
              required
              autocomplete="new"
              name="ItemCatgCd"
              type="text"
              value={inputs.ItemCatgCd}
              onChange={onChange}
            />
          </Control>
        </Column>

        <Column size={6}>
          <Control expanded>
            <SystemCodeSelect
              required
              label="Category Type"
              name="ItemCatgTypeRecIdRef"
              value={inputs.ItemCatgTypeRecIdRef}
              where={{ CodeName: "WOType", Category: "Fleet" }}
              onChange={onChange}
            />
          </Control>
        </Column>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={onChange}
          />
        </Control>
      </Column.Group>
      <Column.Group>
        {CategoryTypes &&
          Array.isArray(CategoryTypes.data) &&
          CategoryTypes.data.find(
            ct =>
              ct.CodeId === "I" &&
              parseInt(ct.RecId) === parseInt(inputs.ItemCatgTypeRecIdRef)
          ) && (
            <Column size={5}>
              <Control expanded>
                <SystemCodeSelect
                  required
                  icon="globe"
                  label="Inspection Code"
                  name="InspectionCdRecIdRef"
                  value={inputs.InspectionCdRecIdRef}
                  where={{ Category: "Fleet", CodeName: "InspectionCd" }}
                  onChange={onChange}
                />
              </Control>
            </Column>
          )}
        <Column>
          <Control expanded>
            <Label>Description</Label>
            <Input
              required
              autocomplete="new"
              name="Description"
              type="text"
              value={inputs.Description}
              onChange={onChange}
            />
          </Control>
        </Column>
      </Column.Group>
    </div>
  );
};
ItemCategoryForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

ItemCategoryForm.defaultProps = {
  inputs: {}
};
export default ItemCategoryForm;
